import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Alex Efremo
 * id FC744BA5-2E98-459F-BBD6-60788B23D93E
 * name garage
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/garage.svg
 * tags
 * - Home Automation 
 */
export const GarageIcon = createSvgIcon(<><path d="M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12M8,15H16V17H8V15M16,18V20H8V18H16Z" /></>, 'GarageIcon');
export default GarageIcon